import { useState, useEffect } from 'react';
import { supabase } from '../../../../api';
import { Box, Grid, Typography } from '@mui/material';
import ArticleCard from '../../../UI/ArticleCard/ArticleCard';

const Body = ({ user }) => {
  let [allPosts, setAllPosts] = useState([]);

  useEffect(
    () => {
      fetchPosts();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const fetchPosts = async () => {
    let { data: posts, error } = await supabase.from('posts').select('*');
    if (error) console.log(error);
    else setAllPosts(posts);
  };

  if (allPosts === undefined) {
    return <Typography>Still loading...</Typography>;
  }

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'left',
        }}>
        <Typography variant='h3' sx={{ fontWeight: 'bold', m: '1rem', mt: '2rem' }}>
          Case Studies
        </Typography>
        <Grid container alignItems='stretch'>
          {allPosts
            .sort((a, b) => b.created_at.localeCompare(a.created_at))
            .filter((post) => post.published)
            .map((post) => {
              return (
                <ArticleCard
                  key={post.id}
                  id={post.id}
                  summary={post.summary}
                  header={post.data.header}
                  date={post.created_at}
                  membershipLevel={user.membershipLevel}
                />
              );
            })}
        </Grid>
      </Box>
    </Box>
  );
};

export default Body;
